export default __webpack_public_path__ + "static/Handsome-Regular-1a797007aa055dba2ff3d594071fb0df.woff";